import { jwtDecode } from 'jwt-decode';
import { Navigate } from 'react-router-dom';

const PrivateDirectorRoute = ({ children }) => {
  const token = localStorage.getItem('director_token');
  if (!token) return <Navigate to="/director/login" replace />;

  try {
    const decoded = jwtDecode(token);
    if (decoded.exp && decoded.exp * 1000 < Date.now())
      return <Navigate to="/director/login" replace />;
    if (decoded.role !== 'director')
      return <Navigate to="/director/login" replace />;
    if (decoded.tempPassword)
      return <Navigate to="/director/change-password" replace />;
    return children;
  } catch {
    return <Navigate to="/director/login" replace />;
  }
};

export default PrivateDirectorRoute;
